<template lang="pug">
  .agv-ri-payment-methods
    .payment-method(v-if="renter.is_payment_via_modulbank_allowed")
      | Картой онлайн
    .payment-method(v-if="renter.is_payment_via_robokassa_allowed")
      | Картой или электронными деньгами
    .payment-method(v-if="renter.is_payment_via_sberbank_allowed && town.supports_cash_and_sberbank")
      | Переводом на карту
    .payment-method(v-if="renter.is_payment_via_wire_transfer_allowed")
      | Банковским переводом
    .payment-method(v-if="renter.is_payment_via_cash_allowed && town.supports_cash_and_sberbank")
      | Наличными
</template>

<script>
  import aggregatorAllowedPaymentMethodsFor from "Aggregator/lib/aggregatorAllowedPaymentMethodsFor";

  export default {
    name: 'agv-ri-payment-methods',
    props: {
      renter: Object,
      townId: Number
    },
    computed: {
      town() {
        return this.$store.state.town.townsById[this.townId];
      }
    }
  }
</script>

<style scoped>

</style>
